export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/AlertCloseSuccess.c8dcfcf8.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};